import { Text } from '@mantine/core';
import { IconChevronRight, IconWand } from '@tabler/icons-react';
import cn from 'classnames';
import * as React from 'react';

import BaseClickable from '@/components/ui/BaseClickable';
import MarkdownRenderer from '@/components/ui/MarkdownRenderer';
import { extractLoaderContent } from '@/utils/unwrapMarkdownCodeFence';

import s from './ChatLoader.module.scss';

type Props = {
  text?: string | null;
  onTextClick?: () => void;
  className?: string;
  variant?: 'mobile' | 'desktop';
};

const ChatLoader: React.FC<Props> = ({ text, onTextClick, className, variant = 'mobile' }) => {
  const isDesktop = variant === 'desktop';
  const { titleText, bodyContent } = extractLoaderContent(text);

  return (
    <div className={cn(s.root, className, isDesktop && s.root_desktop)}>
      <div className={s.root__header}>
        <span className={s.root__icon}>
          <IconWand size={isDesktop ? 20 : 18} />
        </span>
        {titleText ? (
          <Text key={titleText} c="dimmed" size={isDesktop ? 'md' : 'sm'} fw={600} className={s.root__title}>
            {titleText}
          </Text>
        ) : (
          <span className={s['root__title-skeleton']} />
        )}
      </div>
      {bodyContent && (
        <div className={s.root__body}>
          <div className={s['root__body-inner']}>
            <MarkdownRenderer
              content={bodyContent}
              className={s.root__markdown}
              paragraphClassName={s['root__markdown-paragraph']}
            />
          </div>
        </div>
      )}
      {onTextClick && (
        <BaseClickable className={s.root__link} onClick={onTextClick}>
          <Text size="sm" fw={500} c="blue">
            Показать подробно
          </Text>
          <IconChevronRight className={s['root__link-icon']} size={16} />
        </BaseClickable>
      )}
    </div>
  );
};

export default React.memo(ChatLoader);
